import { Language } from './language';

export interface I18nMessage {
  identifier: string;
  defaultText: string;
  texts?: {
    language: Language;
    text: string;
  }[];
  params?: any;
}

export function extractText(i18nMessage: I18nMessage, language: string): string {
  const textOpt = i18nMessage.texts?.find(t => t.language.identifier === language);
  if (textOpt) {
    return textOpt.text;
  }
  return i18nMessage.defaultText;
}
